import { useUserAccess } from '@/hooks/useUserAccess';
import { useTranslation } from '@/hooks/useTranslation';
import DownloadIcon from '@simplywallst/ui-core/icons/DownloadPdfSolid';
import { MODAL } from '../constants';
import type { ActionClickProps, Action } from '../types';

export const usePdfAction = (): Action => {
  const t = useTranslation();
  const userAccess = useUserAccess();

  const handleClick = ({
    trackEvent,
    setActiveModal,
    canonicalUrl,
  }: ActionClickProps) => {
    trackEvent({
      type: 'track',
      action: 'click',
      subject: 'downloadPdf',
    });
    if (userAccess.data.canGetCompanyReportPdf !== true) {
      setActiveModal(MODAL.PLANS);
      return;
    }
    window.open(`${canonicalUrl}?viewmode=print`);
  };

  return {
    key: 'pdf',
    isDisabled: userAccess.status !== 'success',
    isHidden: RUNTIME_ENV === 'native',
    smallProps: {
      label: t('page.companyReport.header.actions.downloadToPDF'),
      icon: <DownloadIcon />,
    },
    handleClick,
  };
};
